<div class="card clearfix">
    <div
        class="mybets-betslip-history-header_title"
        [ngClass]="{ collapsed: collapsed, expanded: !collapsed && !myBetsListContext.isPrintView }"
        (click)="toggleClick()">
        @if (!myBetsListContext.isPrintView) {
            <div class="mybets-betslip-history-header_state-indicator-container">
                <span class="mybets-betslip-history-header_state-indicator font-small" *msShowInEpcot="{ showInEpcot: false, module: module }">
                    <vn-icon size="12" [name]="!collapsed ? 'theme-down' : 'theme-right'" />
                </span>
                <span class="mybets-betslip-history-header_state-indicator font-small" *msShowInEpcot="{ showInEpcot: true, module: module }">
                    <vn-icon size="16" [name]="!collapsed ? 'theme-up' : 'theme-down'" />
                </span>
            </div>
        }

        <div class="mybets-betslip-history-header_edit-title-wrapper bold highlight">
            <span>{{ betslip.editBetTitle }}</span>
            @if (myBetsListContext.isPrintView) {
                <span> - {{ betslipId }} </span>
            }
        </div>
        @if (isEpcotEnabled) {
            <div class="mybets-betslip-history-header_place-date font-small highlight">
                {{ betslip.betPlacedDate | msMyBetsEventDatePipe }}
            </div>
        }
    </div>

    @if (!collapsed || myBetsListContext.isPrintView) {
        @for (bet of betslip.bets; track bet; let last = $last) {
            <div class="mybets-betslip-info_right-section clearfix">
                <span class="mybets-betslip-bet-odds">{{ bet.odds | msMyBetsOddsPipe }}</span>
            </div>
            <div class="mybets-betslip-info_pick-data clearfix">
                <ms-my-bets-betslip-option-name [bet]="bet" />
                <ms-my-bets-betslip-market-name [bet]="bet" />
            </div>
            <div class="mybets-betslip-non-event-info_event-name highlight">{{ bet.eventName }}</div>
            <div class="mybets-betslip-non-event-info_event-date font-small">{{ bet.eventDate | msMyBetsEventDatePipe }}</div>
            @if (!last) {
                <div class="mybets-card-divider with-margin"></div>
            }
        }

        <div class="mybets-card-divider"></div>
        <ms-my-bets-betslip-summary [betslip]="betslip" [myBetsListContext]="myBetsListContext" [isEditBetHistory]="true" [isCurrentBet]="isFirst" />

        @if (!myBetsListContext.isPrintView) {
            <div class="mybets-card-divider with-margin"></div>
            <div class="mybets-edit-bet-history-bet-info">
                <button class="copy-clipboard-btn" ds-button kind="tertiary" variant="flat" size="small" (click)="copyToClipboard($event)">
                    <vn-icon name="theme-copy-clipboard" slot="start" />
                    {{ sitecoreMyBets.myBets.BetSlipNr }}: {{ betslipId }}
                </button>
                <div class="clear"></div>
            </div>
        }
    }
</div>
